import { getSupabaseClient } from './supabase.client.js';

/**
 * Repositorio de `otros_descuentos` (migración 33, spec
 * liquidacion-otros-descuentos) para el panel de staff. SOLO LECTURA desde el
 * navegador, mismo criterio que `adelantos.repository.js`: la tabla es
 * append-only, con únicamente una política de SELECT admin
 * (`otros_descuentos_admin_read`) y sin política de escritura. Los únicos
 * escritores son las RPCs `crear_otro_descuento`/`anular_otro_descuento`,
 * llamadas desde `api/payroll-movimientos.js` (service_role).
 */

const OTRO_DESCUENTO_COLUMNS =
    'id, empleado_id, fecha, monto, concepto, creado_por, creado_at, anulado_at, anulado_por, anulado_motivo';

/**
 * Re-lanza un error de Supabase preservando el código de Postgres.
 * @param {{ message: string, code?: string }} error
 * @returns {never}
 */
function rethrow(error) {
    const err = new Error(error.message);
    if (error.code) err.code = error.code;
    throw err;
}

/**
 * Otros descuentos (activos y anulados), fecha descendente. `empleadoIds`/
 * `desde`/`hasta` (opcionales) filtran por `empleado_id`/`fecha`. Anulados
 * incluidos a propósito: el cajón muestra la lista activa y la anulada.
 *
 * Si Supabase no está configurado devuelve `[]` (misma degradación que
 * `listAdelantos`).
 * @param {{ empleadoIds?: string[], desde?: string, hasta?: string }} [params]
 * @returns {Promise<Array<object>>}
 * @throws {Error} si Supabase responde con error
 */
export async function listOtrosDescuentos({ empleadoIds, desde, hasta } = {}) {
    const client = getSupabaseClient();
    if (!client) return [];

    let query = client.from('otros_descuentos').select(OTRO_DESCUENTO_COLUMNS).order('fecha', { ascending: false });
    if (Array.isArray(empleadoIds) && empleadoIds.length > 0) query = query.in('empleado_id', empleadoIds);
    if (desde) query = query.gte('fecha', desde);
    if (hasta) query = query.lte('fecha', hasta);

    const { data, error } = await query;
    if (error) rethrow(error);
    return data ?? [];
}
